module.exports = __webpack_public_path__ + "84bbb06cfeab139d7a527a5e0f2ef1af.png";